import { Flex, spaces } from '@electricjs/arc';
import { ReactNode } from 'react';

type TableHeaderBarProps = {
  title: ReactNode;
  chips?: ReactNode;
  actions?: ReactNode;
  padding?: string | number;
};

const TableHeaderBar = ({
  title,
  chips,
  actions,
  padding = spaces.space_m,
}: TableHeaderBarProps) => (
  <Flex width="100%" p={padding} vAlignContent="center" hAlignContent="between">
    <Flex vAlignContent="center" columnGap={spaces.space_s_rem}>
      {title}
      {chips}
    </Flex>
    {actions && (
      <Flex alignItems="flex-end" columnGap={spaces.space_m}>
        {actions}
      </Flex>
    )}
  </Flex>
);

export default TableHeaderBar;
